import RU from 'assets/icons/flag_ru.svg';
import BY from 'assets/icons/flag_by.svg';

const ruMask = {
  mask: '{+7} (000) 000-00-00',
  shortMask: '+7',
  country: 'Россия',
  icon: RU,
  iconAlt: 'Флаг России',
};
const byMask = {
  mask: '{+375} 00 000-00-00',
  shortMask: '+375',
  country: 'Беларусь',
  icon: BY,
  iconAlt: 'Флаг Беларуси',
};

export const masks = [ruMask, byMask];
